import React, { useEffect, useState } from "react";
import DigipingMark from "./DigipingMark";

/**
 * DigiPing host avatar: real club logo when available, otherwise AgentMark.
 * Matches ClubAdminProfiling DigipingWizardMark behavior.
 */
export default function DigipingHostMark({
  clubLogoSrc,
  size = 32,
  agentId = "pingflo",
  imgClassName = "",
  className = "",
  title = "Pingflo",
}) {
  const [imgFailed, setImgFailed] = useState(false);
  useEffect(() => {
    setImgFailed(false);
  }, [clubLogoSrc]);

  if (clubLogoSrc && !imgFailed) {
    return (
      <img
        src={clubLogoSrc}
        alt=""
        title={title}
        width={size}
        height={size}
        className={imgClassName || className}
        style={{
          width: size,
          height: size,
          borderRadius: Math.round(size * 0.28),
          objectFit: "contain",
          background: "rgba(255,255,255,0.92)",
          display: "block",
        }}
        onError={() => setImgFailed(true)}
      />
    );
  }

  return (
    <DigipingMark
      agentId={agentId}
      size={size}
      className={className}
      title={title}
    />
  );
}
